/* global Shopify */

import { component } from 'picoapp';
import Glide from '@glidejs/glide';

export default component((node, ctx) => {

  const carousel = node.querySelector('.js-hero-carousel');

  const glide = new Glide(carousel, {
    type: 'carousel',
    startAt: 0,
    perView: 1,
    rewind: false,
    focusAt: 'center',
    animationDuration: 600,
  });

  if (Shopify.designMode) {
    window.addEventListener('shopify:block:select', (e) => {
      const slideIndex = e.target.dataset.index;
      glide.go(`=${slideIndex}`);
    });
  }

  glide.mount();
});
